import * as React from "react";
import type { SVGProps } from "react";
const SvgHourglass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.05 10.95A7 7 0 0 0 8.394 12 7 7 0 0 0 5 18v2a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-2a7 7 0 0 0-3.394-6A7 7 0 0 0 19 6V4a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v2a7 7 0 0 0 2.05 4.95M12 13a5 5 0 0 0-4.583 3h9.166A5 5 0 0 0 12 13M7 6V4h10v2zm.417 2h9.166a5 5 0 0 1-9.166 0M7 20v-2h10v2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHourglass;
